export default ({React,connect,CollapsePanel,ToolbarActions,StylePicker,slate})->

  { Block, Text } = slate

  class TrainingProgressToolbar extends React.Component

    constructor:(props)->
      super(props)
      @state = {
        path:""
      }

    componentDidMount:->
      @stateFromTag()

    componentDidUpdate:(prev_props,prev_state)->
      @stateFromTag() if prev_props.value.change().value.startBlock != @props.value.change().value.startBlock 

    stateFromTag:->
      tag = @getTag()
      return if !tag
      attrs = tag.data.toObject() 
      @setState({path:attrs.path}) if attrs.path?
      
    getTag:->
      change = @props.value.change()
      tags = change.value.blocks.filter (node)-> node.type == "trainingprogress"
      return tags.get(0) if tags.size > 0

    updateEditor:()->
      tag = @getTag()
      return if !tag
      change = @props.value.change()
      attrs = {}
      attrs.path = if @state.path? then @state.path else null
      change.setNodeByKey(tag.key, {data: {...tag.data.toObject(),...attrs}}) 
      @props.setValue(change.value)

    render:->
      <CollapsePanel title="Maths Tools">
        <div>
          <div className="formhoriz">
            <label>Page Path</label>
            <input className="form-control" type="text" value={@state.path}  onChange={(e)=>@setState({path:e.target.value},=> @updateEditor())} />
          </div>
        </div>
      </CollapsePanel>

  connect(
    (state)->
      settings:state.settings
      toolbar_width:state.toolbar_width
      toolbars_active:state.toolbars_active
  )(TrainingProgressToolbar)